import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { Baseproperties } from "src/app/views/utility/baseproperties";

@Injectable({
  providedIn: 'root'
})
export class MycredentialsService {
  constructor(
    private httpClient: HttpClient,
    private route: Router
  ) { }

  baseproperties: Baseproperties = new Baseproperties();
  private baseURL = `${new Baseproperties().gatewayBaseURL}/common`;

  scrollHeight: string = '340.8px';

  downloadexcel_text = "Please download this Excel data. It will be saved in your Download directory by default.";
  downloadexcelformate_text = "Please download this Excel Format. It will be saved in your Download directory by default. Please check for the latest file that is downloaded since Excel does a version control if the file with the same name exists. Open the Excel file and enter the requested information in the columns provided.";
  excelformate_text = "Please download this Excel Format. It will be saved in your Download directory by default. Please check for the latest file that is downloaded since Excel does a version control if the file with the same name exists. Open the Excel file and enter the requested information in the columns provided.";

  getCredentialList(): Observable<any> {
    return this.httpClient.get(`${this.baseURL}/mycredential/getcredentials`);
  }

  createCredential(payload: any): Observable<Object> {
    return this.httpClient.post(`${this.baseURL}/mycredential/addcredential`, payload);
  }

  getCredentialById(id: number): Observable<any> {
    return this.httpClient.get(`${this.baseURL}/mycredential/getmodify/${id}`);
  }

  updateCredential(payload: any): Observable<any> {
    return this.httpClient.post(`${this.baseURL}/mycredential/modifycredential`, payload);
  }


  private credentialRowsPerPage: number = 10;

  setCredentialRowsPerPage(value: number) {
    this.credentialRowsPerPage = value;
  }

  getCredentialRowsPerPage(): number {
    return this.credentialRowsPerPage;
  }
  deleteCredentials(payload): Observable<any> {
    return this.httpClient.delete(`${this.baseURL}/mycredential/deletecredential`,{ body: payload });
  }

}
